<!-- 公共头部 -->
<template>
  <div class="comHeaderWrap">
    <div class="w comHeader">
      <div class="logo">
        <router-link :to="{ name: 'index' }" v-if="showLogo">
          <img src="../assets/imgs/wdl.png" alt="" />
        </router-link>
      </div>

      <div class="comHeader_right">
        <!-- <router-link :to="{name:'index'}" class="link">{{ $t("header.version") }}</router-link> -->
        <router-link :to="{ name: 'schoolList' }" class="link">{{
          $t("header.colleges")
        }}</router-link>

        <el-dropdown class="el_drop">
          <div>
            <i class="iconfont icon-role"></i>
            <span class="username"
              >{{ name ? name : "" }}
              <span v-if="this.ip && this.ip !== 'null'">({{ this.ip }})</span>
            </span>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><div class="span" @click="person" v-if="role == 'ip'">
                {{ $t("header.login") }}
              </div></el-dropdown-item
            >
            <el-dropdown-item
              ><div class="span" @click="enroll" v-if="role == 'ip'">
                {{ $t("header.enroll") }}
              </div></el-dropdown-item
            >
            <el-dropdown-item
              ><div class="span" @click="email" v-if="role == 'userip'">
                {{ $t("header.lookemail") }}
              </div></el-dropdown-item
            >
            <el-dropdown-item
              ><div class="span" @click="logout" v-if="role">
                {{ $t("header.out") }}
              </div></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          class="el_drop"
          v-if="region_or !== '1' || region_or_current !== '1'"
        >
          <i class="iconfont icon-tubiaoku-"></i>
          <el-dropdown-menu slot="dropdown" v-if="language == 'zh'">
            <el-dropdown-item
              ><span @click="handleLang('zh')">中文</span></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="handleLang('en')">英文</span></el-dropdown-item
            >
          </el-dropdown-menu>
          <el-dropdown-menu slot="dropdown" v-else>
            <el-dropdown-item
              ><span @click="handleLang('zh')">Chinese</span></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="handleLang('en')">English</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  props: {
    showLogo: {
      default: true,
    },
  },
  data() {
    return {
      seeemail: false,
      name: null,
      ip: null,
      language: "",
      role: "",
      region_or: 0,
      region_or_current: 0,
    };
  },

  components: {},

  computed: {},
  created() {
    // console.log('this.name',this.$route.path)
    console.log("this.$route.path");
    if (this.$route.path !== "/" && !this.$route.query.user_id) {
      if (window.localStorage.getItem("region_copy")) {
        this.region_or_current = window.localStorage.getItem("region_copy");
      } else {
        if (window.localStorage.getItem("lang") == "en") {
          this.$message({
            message: "Login is invalid! Please log in again",
            type: "warning",
          });
        } else {
          this.$message({
            message: "登录失效！请重新登录",
            type: "warning",
          });
        }

        this.logout();
      }
    } else {
      this.region_or_current = window.localStorage.getItem("region_copy");
    }
    if (window.localStorage.getItem("region")) {
      this.region_or = window.localStorage.getItem("region");
    }
    console.log(this.region_or_current !== "1", this.region_or !== "1");
    if (window.localStorage.getItem("region") == 0) {
      this.language = "zh";
      this.$i18n.locale = "zh";
      window.localStorage.setItem("lang", this.language);
      window.localStorage.setItem("region", 0);
      this.$emit("changeLang", "zh");
    } else if (window.localStorage.getItem("region") == 1) {
      this.language = "en";
      this.$i18n.locale = "en";
      window.localStorage.setItem("lang", this.language);
      window.localStorage.setItem("region", 1);
      this.$emit("changeLang", "en");
    } else {
      this.language = "en";
      this.$i18n.locale = "en";
      window.localStorage.setItem("lang", this.language);
      window.localStorage.setItem("region", 1);
      this.$emit("changeLang", "en");
    }
    if ((window, localStorage.getItem("role"))) {
      this.role = window.localStorage.getItem("role");
    }
    this.name = window.localStorage.getItem("userName");

    // console.log(this.name)
    this.ip = window.sessionStorage.getItem("ipclients");
  },
  methods: {
    email() {
      this.$router.push({
        path: "users",
      });
    },
    // 语言切换按钮
    handleLang(key) {
      // key 传入‘zh’ 或者‘en’
      this.language = key;
      this.$i18n.locale = key; //
      window.localStorage.setItem("lang", this.language);
      if (key == "zh") {
        window.localStorage.setItem("region", 0);
      } else if ((key = "en")) {
        window.localStorage.setItem("region", 1);
      }
      this.$emit("changeLang", key);
      // console.log(key)
    },
    // 退回登录
    logout() {
      store.clearCookie("token");
      window.localStorage.clear();
      var d = new Date().getTime(); //获取系统当前时间
      window.localStorage.setItem("logoutTime", d);
      this.$router.push({
        name: "login",
      });
    },
    // 注册个人账号
    enroll() {
      this.$router.push({
        name: "enroll",
      });
    },
    // 个人账号登录
    person() {
      this.$router.push({
        name: "personLogin",
      });
    },
  },
};
</script>
<style lang='less' scoped>
/deep/ .el-dropdown-selfdefine {
  height: 20px;
}
/deep/.el-dropdown {
  height: 20px;
}
.comHeaderWrap {
  height: 60px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.comHeader {
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
}
.logo {
  img {
    width: 140px;
  }
}
.comHeader_right {
  display: flex;
  align-items: center;
  color: #0e101a;
  .link {
    margin-right: 30px;
    color: #606266;
  }
  span {
    // line-height: 60px;
    margin-right: 14px;
  }
  .name {
    color: #0e101a;
    font-size: 15px;
    font-weight: 700;
  }
  .el_drop {
    margin-right: 10px;
    .iconfont {
      font-size: 20px;
      // line-height: 60px;
      color: #0068a2;
    }
    .username {
      margin-left: 4px;
    }
  }
}
.span {
  text-align: center;
  min-width: 50px;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ComHeader.vue